import { queryClient } from "@/queryClient"

export type CreateRoleQuery = {
  name: string
  permissions: string[]
}

export type CreateRoleResponse = {
  name: string
  permissions: string[]
}

export const createRole = async (
  params: CreateRoleQuery
) => {
  const { body } = await api.post<CreateRoleResponse>(
    "/users/roles/new/",
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })
  return body
}
